/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AppsControllerListAllApps200ResponseInner,
} from '../models/index';
import {
    AppsControllerListAllApps200ResponseInnerFromJSON,
    AppsControllerListAllApps200ResponseInnerToJSON,
} from '../models/index';

export interface AppsControllerConnectAppRequest {
    id: string;
    redirect?: string;
}

export interface AppsControllerConnectAppCallbackRequest {
    id: string;
    state: string;
    code: string;
    error?: string;
}

export interface AppsControllerDisconnectAppRequest {
    id: string;
}

export interface AppsControllerTestConnectionRequest {
    id: string;
}

/**
 * ActionsAppsApi - interface
 * 
 * @export
 * @interface ActionsAppsApiInterface
 */
export interface ActionsAppsApiInterface {
    /**
     * Connect an app
     * @summary Connect an app
     * @param {string} id 
     * @param {string} [redirect] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsAppsApiInterface
     */
    appsControllerConnectAppRaw(requestParameters: AppsControllerConnectAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Connect an app
     * Connect an app
     */
    appsControllerConnectApp(requestParameters: AppsControllerConnectAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

    /**
     * Connect an app callback
     * @summary Connect an app callback
     * @param {string} id 
     * @param {string} state 
     * @param {string} code 
     * @param {string} [error] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsAppsApiInterface
     */
    appsControllerConnectAppCallbackRaw(requestParameters: AppsControllerConnectAppCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Connect an app callback
     * Connect an app callback
     */
    appsControllerConnectAppCallback(requestParameters: AppsControllerConnectAppCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Disconnect an app
     * @summary Disconnect an app
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsAppsApiInterface
     */
    appsControllerDisconnectAppRaw(requestParameters: AppsControllerDisconnectAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Disconnect an app
     * Disconnect an app
     */
    appsControllerDisconnectApp(requestParameters: AppsControllerDisconnectAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * List all supported apps
     * @summary List all supported apps
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsAppsApiInterface
     */
    appsControllerListAllAppsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AppsControllerListAllApps200ResponseInner>>>;

    /**
     * List all supported apps
     * List all supported apps
     */
    appsControllerListAllApps(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AppsControllerListAllApps200ResponseInner>>;

    /**
     * Test connection to an app
     * @summary Test connection to an app
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsAppsApiInterface
     */
    appsControllerTestConnectionRaw(requestParameters: AppsControllerTestConnectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>>;

    /**
     * Test connection to an app
     * Test connection to an app
     */
    appsControllerTestConnection(requestParameters: AppsControllerTestConnectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean>;

}

/**
 * 
 */
export class ActionsAppsApi extends runtime.BaseAPI implements ActionsAppsApiInterface {

    /**
     * Connect an app
     * Connect an app
     */
    async appsControllerConnectAppRaw(requestParameters: AppsControllerConnectAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling appsControllerConnectApp().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['redirect'] != null) {
            queryParameters['redirect'] = requestParameters['redirect'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/actions/apps/{id}/connection`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Connect an app
     * Connect an app
     */
    async appsControllerConnectApp(requestParameters: AppsControllerConnectAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.appsControllerConnectAppRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Connect an app callback
     * Connect an app callback
     */
    async appsControllerConnectAppCallbackRaw(requestParameters: AppsControllerConnectAppCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling appsControllerConnectAppCallback().'
            );
        }

        if (requestParameters['state'] == null) {
            throw new runtime.RequiredError(
                'state',
                'Required parameter "state" was null or undefined when calling appsControllerConnectAppCallback().'
            );
        }

        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError(
                'code',
                'Required parameter "code" was null or undefined when calling appsControllerConnectAppCallback().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['error'] != null) {
            queryParameters['error'] = requestParameters['error'];
        }

        if (requestParameters['state'] != null) {
            queryParameters['state'] = requestParameters['state'];
        }

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/actions/apps/{id}/connection/callback`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Connect an app callback
     * Connect an app callback
     */
    async appsControllerConnectAppCallback(requestParameters: AppsControllerConnectAppCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.appsControllerConnectAppCallbackRaw(requestParameters, initOverrides);
    }

    /**
     * Disconnect an app
     * Disconnect an app
     */
    async appsControllerDisconnectAppRaw(requestParameters: AppsControllerDisconnectAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling appsControllerDisconnectApp().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/actions/apps/{id}/connection`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Disconnect an app
     * Disconnect an app
     */
    async appsControllerDisconnectApp(requestParameters: AppsControllerDisconnectAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.appsControllerDisconnectAppRaw(requestParameters, initOverrides);
    }

    /**
     * List all supported apps
     * List all supported apps
     */
    async appsControllerListAllAppsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AppsControllerListAllApps200ResponseInner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/actions/apps`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AppsControllerListAllApps200ResponseInnerFromJSON));
    }

    /**
     * List all supported apps
     * List all supported apps
     */
    async appsControllerListAllApps(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AppsControllerListAllApps200ResponseInner>> {
        const response = await this.appsControllerListAllAppsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Test connection to an app
     * Test connection to an app
     */
    async appsControllerTestConnectionRaw(requestParameters: AppsControllerTestConnectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling appsControllerTestConnection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/actions/apps/{id}/connection/health`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Test connection to an app
     * Test connection to an app
     */
    async appsControllerTestConnection(requestParameters: AppsControllerTestConnectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.appsControllerTestConnectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
